import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const JoltGroupItem = ({ group }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const navigate = useNavigate();

  const handleImageClick = (e, image) => {
    e.stopPropagation(); // Prevent triggering group click
    setSelectedImage(image);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleGroupClick = () => {
    navigate(`/groups/${group.title}`, { state: { groupData: group } });
  };

  // Calculate member count
  const memberCount = group.members ? group.members.length : 0;

  return (
    <>
      <li 
        className="mb-4 flex items-center p-4 dashboard-on-element rounded-lg shadow-md cursor-pointer hover:bg-gray-700 transition-colors"
        onClick={handleGroupClick}
      >
        <img
          src={group.grpAvatar}
          alt={group.title}
          className="w-24 h-24 object-cover rounded-lg mr-4"
          onClick={(e) => handleImageClick(e, group.grpAvatar)}
        />
        <div className="flex-grow">
          <span className="text-lg font-medium block">{group.title}</span>
          <div className="flex items-center mt-1 text-gray-300">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span>{memberCount} {memberCount === 1 ? 'Member' : 'Members'}</span>
          </div>
        </div>
      </li>

            {selectedImage && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50 p-4"
          onClick={handleOverlayClick}
        >
          <div className="relative">
            <img 
              src={selectedImage} 
              alt="Selected" 
              className="max-w-full max-h-[80vh] md:max-w-[800px] md:max-h-[600px] rounded-lg object-contain" 
            />
            <button
              className="absolute top-2 right-2 text-white text-2xl bg-black bg-opacity-50 w-8 h-8 rounded-full flex items-center justify-center"
              onClick={handleClose}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default JoltGroupItem;